import React from "react";

const B2BenefitsMain = () => {
  return (
    <div className="LvlBenefitsMainContainer">
      <ul>
        <li>
          <span>📝 Structured Learning: </span>The course begins with an
          introduction to the easier aspects of B2 German grammar, consisting of
          B2.1 and B2.2, providing a solid foundation.
        </li>
        <li>
          <span>🌐 Diverse Topics:</span>Explore a wide variety of topics,
          deepening your understanding of German culture through idioms and
          quotes.
        </li>
        <li>
          <span>💬 Advanced Discussions: </span>Engage in discussions on
          challenging topics and work-related issues, enhancing your
          conversational abilities.
        </li>
        <li>
          <span>📰 Formal Texts: </span>
          Gain the ability to understand formal texts found in journals and
          newspapers, broadening your comprehension skills.
        </li>
        <li>
          <span>🌍 Thematic Debates: </span>Participate in discussions on themes
          such as politics, economy, technology, relationships, and the
          environment.
        </li>
        <li>
          <span>🎓 Language Command: </span>: Achieve a strong command of the
          language, enabling you to express personal views and opinions in both
          formal and informal settings.
        </li>
        <li>
          <span>📚 Analytical Skills: </span>
          Learn to discuss, analyze, and interpret various texts, improving your
          critical thinking and analytical abilities.
        </li>
        <li>
          <span>🗣️ Detailed Expression: </span>Explain yourself clearly and in
          detail on a wide range of topics, ensuring effective communication.
        </li>
        <li>
          <span>👥 Fluent Conversations: </span>Upon completion, you'll be able
          to lead fluent and spontaneous conversations with native speakers,
          enhancing your interaction skills.
        </li>
        <li>
          <span>🎓 Specialized Discussions: </span>
          Understand and participate in specialized discussions, furthering your
          expertise in various subjects.
        </li>
        <li>
          <span>📜 Certification: </span>Obtain a certificate that serves as
          proof of proficiency in public, professional, and educational
          situations, opening doors to new opportunities.
        </li>
        <p>
          Join Prizma Academy’s B2 Level German Course in Bangalore and take
          your language skills to new heights, preparing you for success in both
          personal and professional realms!
        </p>
      </ul>
    </div>
  );
};

export default B2BenefitsMain;
